import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "55",
  height: "8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  d: "M.5 4.5h53.038M50.5.964 54.036 4.5 50.5 8.036"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }